import { type FC, type HTMLAttributes } from 'react'

import { useAdditionalMessage } from '@Hooks/useAdditionalMessage'

import { type TooltipPlacement } from '../Tooltip.types'

import AdditionalMessageButton from './_internal/AdditionalMessageButton'
import { type DescriptionMessage, type MediumSizeView } from './AdditionalMessage.types'
import * as styles from './styles'

export type AdditionalMessageProps = {
  id: string
  descriptionMessage: DescriptionMessage
  iconAriaLabel?: string
  mediumSizeView?: MediumSizeView
  onIconClick?: VoidFunction
  tooltipPlacement?: TooltipPlacement
  isFullWidth?: boolean
} & HTMLAttributes<HTMLDivElement>

const AdditionalMessage: FC<AdditionalMessageProps> = ({
  children,
  descriptionMessage,
  iconAriaLabel,
  id,
  onIconClick,
  mediumSizeView = 'tooltip',
  tooltipPlacement = 'bottom-start',
  isFullWidth = false,
  ...rest
}) => {
  const { toggle, renderMessageView, buttonProps } = useAdditionalMessage({
    descriptionMessage,
    id,
    tooltipPlacement,
    iconAriaLabel,
    mediumSizeView,
  })

  const handleClick = () => {
    toggle()
    onIconClick?.()
  }

  return (
    <div {...rest} css={styles.container}>
      {children && <div css={styles.childrenWrapper(isFullWidth)}>{children}</div>}
      {renderMessageView(<AdditionalMessageButton {...buttonProps} onClick={handleClick} />)}
    </div>
  )
}

export default AdditionalMessage
